import { TREND_NOTE, isMeaningfulChange } from '../../constants';

export const HEADER_TEXT = {
    title: 'Did the blind spot shrink?',
    description: 'Size of the Self minus All But Self gap at each 360. A narrowing gap means self-perception moved closer to how stakeholders see the same behaviors.',
    note: TREND_NOTE,
};

export const COLUMNS = {
    category: 'Category',
    gapEarlier: 'Gap earlier',
    gapLatest: 'Gap latest',
    movement: 'Movement',
};

// The API sends "-" for a round with no gap to report.
export const hasGap = (gap) => typeof gap === 'number';

// How the size of the gap changed between the two rounds; null when either
// round has no gap, since there's nothing to compare.
//
// Deliberately |latest| − |earlier|, not latest − earlier: this table is about
// the gap's SIZE, not its direction. A gap going +0.20 → −0.20 has flipped from
// overrating to underrating but is exactly as wide as it was, and reporting
// that as a −0.40 improvement would be a lie.
export const movementFor = (row) => {
    if (row.movement != null) return row.movement;
    if (!hasGap(row.gapEarlier) || !hasGap(row.gapLatest)) return null;
    return Math.abs(row.gapLatest) - Math.abs(row.gapEarlier);
};

// A shrinking gap is the good direction here — self-perception moved toward how
// stakeholders see the same behaviors — so a negative movement is the win.
// That's the opposite of the other trend sections, where up is good.
export const MOVEMENT_LABEL = {
    narrowed: 'Narrowed',
    widened: 'Widened',
    same: 'About the same',
};

export const movementToneFor = (movement) => {
    if (!isMeaningfulChange(movement)) return 'same';
    return movement < 0 ? 'narrowed' : 'widened';
};

// Shown in a cell with no gap, and in Movement when there's nothing to compare.
export const NO_VALUE = '—';
